import React, { useState } from 'react';
import { Button, Dropdown, Menu, Modal } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { auth } from '../../lib/firebaseAuth';
import { showNotification } from '../../shared/utils/notifications';

type Props = { event: LeagueFeed.Event; viewer?: Users.User };

/**
 * LG-61 duyuru seçenekleri: girişli üye (yazan hariç) şikâyet eder. Gizleme/kaldırma kararı yönetim
 * panelinde (admin ya da kulübün yöneticisi).
 */
export default function FeedAnnouncementMenu({ event, viewer }: Props) {
  const { t } = useTranslation('leagues');
  const [reported, setReported] = useState(false);
  const announcement = event.veri.duyuru;
  if (!viewer?.id || !announcement || event.veri.yazan?.id === viewer.id || reported) return null;

  const report = () =>
    Modal.confirm({
      title: t(
        event.veri.yazan?.rol === 'tenisio'
          ? 'detail.feed.announcement.reportConfirmPlatform'
          : 'detail.feed.announcement.reportConfirm',
      ),
      okText: t('detail.posts.report'),
      cancelText: t('detail.posts.cancel'),
      onOk: async () => {
        try {
          const user = auth.currentUser;
          if (!user) throw new Error('AUTH');
          const response = await fetch(
            `/api/club-announcement?id=${encodeURIComponent(announcement.id)}&report=1`,
            { method: 'POST', cache: 'no-store', headers: { Authorization: `Bearer ${await user.getIdToken()}` } },
          );
          if (!response.ok) throw new Error(String(response.status));
          setReported(true);
          showNotification('success', t('detail.posts.reported'));
        } catch {
          showNotification('error', t('detail.posts.reportError'));
        }
      },
    });

  return (
    <Dropdown
      overlay={
        <Menu>
          <Menu.Item key="report" onClick={report}>
            {t('detail.posts.report')}
          </Menu.Item>
        </Menu>
      }
      trigger={['click']}
      placement="bottomRight"
    >
      <Button
        type="text"
        className="feed-post__more"
        icon={<MoreOutlined aria-hidden="true" />}
        aria-label={t('detail.posts.options')}
        title={t('detail.posts.options')}
      />
    </Dropdown>
  );
}

FeedAnnouncementMenu.defaultProps = { viewer: undefined };
